<script>
import { HorizontalBar } from 'vue-chartjs';
import { scale } from '../../utils/colors';

export default {
  extends: HorizontalBar,
  props: {
    title: {
      type: String,
      default: '',
    },
    labels: {
      type: Array,
      default: null,
    },
    datasets: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    // If labels are provided, use those labels, else get unique labels from the data
    const labels = this.labels
      ? this.labels
      : [
          // Ensure labels are unique
          ...new Set(
            this.datasets.reduce(
              (prev, cur) =>
                // Concat to prev dataset's array of labels.
                prev.concat(
                  // Map each dataset's data to create an array of labels.
                  cur.data.map(data_el => data_el.label)
                ),
              // Start reducer function with a blank array
              []
            )
          ),
        ];

    const colors = scale(this.datasets.length);
    const datasets = this.datasets.map((dataset, i) => {
      let data = labels.map(() => 0);
      dataset.data.map(obj => (data[labels.indexOf(obj.label)] = obj.value));

      return {
        label: dataset.label,
        data,
        backgroundColor: colors[i],
        fill: true,
        indexAxis: 'x',
      };
    });

    const chartdata = {
      datasets,
      labels,
    };

    const options = {
      ...this.options,
      title: {
        display: true,
        text: this.title,
      },
      maintainAspectRatio: false,
    };

    this.renderChart(chartdata, options);
  },
};
</script>
